import React, { useState } from 'react'
import StateForm from './StateForm';
import StateList from './StateList';

const State = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <StateForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <StateList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default State